module.exports = __webpack_public_path__ + "static/media/ios-app-store-en-US.9eee833d.png";